import React from 'react';
import { useSelector } from 'react-redux';

import { TypeStep } from 'FRONTEND/components/Calendar/AppointmentForm/TypeStep';

export const AvailableTypeStep = ({
  ...otherProps
}) => {
  const typeList = useSelector((state) => state.booking.availableTypeList);

  return (
    <TypeStep typeList={typeList} {...otherProps} />
  );
};
